import { render, staticRenderFns } from "./heightBlock.vue?vue&type=template&id=188b17c2&scoped=true&"
import script from "./heightBlock.vue?vue&type=script&lang=js&"
export * from "./heightBlock.vue?vue&type=script&lang=js&"
import style0 from "./heightBlock.vue?vue&type=style&index=0&id=188b17c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188b17c2",
  null
  
)

export default component.exports